import actions from './actions';
import mutations from './mutations';
import getters from './getters';

const data = {
  industryChartData: {},
  industryLegendData: [],
  industryDisplayMode: 'single',
  industryPageMaxPercent: 0,
  industryPageMaxDecimal: 0,
};

export default {
  namespaced: true,
  state: data,
  getters,
  mutations,
  actions,
};
